import { h, Component, Fragment, createRef } from 'preact'
import { Slugify, isEmptyObject } from '../../js/modules/utilities.js'

// Composant Principal (liste de tous les contracts)
export class BandeListeContrats extends Component {
   state = {
      contractList: this.props.contractList,
      title: this.props.title,
      button: this.props.button,
      showAllContracts: false,
      segRefZ: window.dataStoreHP.segRefZ,
      cardNumber: this.props.cardNumber,
   }

   focusedLink = createRef()

   componentDidUpdate() {
      if (this.state.showAllContracts === true) {
         this.focusedLink.current.focus()
      }
   }

   componentDidMount() {
      // Si on vient de la bande second contrat, on a un #multi-contracts-mobile dans l'URL
      if (document.location.hash === '#multi-contracts-mobile') {
         // on ouvre tous les contrats
         this.setState({ showAllContracts: true })
         // on scroll sur la liste de contrats
         document.getElementById('multi-contracts-mobile').scrollIntoView()
      }
   }

   toggleContracts = () => {
      const showAllContracts = !this.state.showAllContracts
      this.setState({ showAllContracts })
   }

   render() {
      const { segRefZ, contractList, title, cardNumber, showAllContracts, button } = this.state
      return (
         <div class="container-fluid">
            <div id="multi-contracts-mobile" data-testid="bande-liste-contrats" class={`multi-contracts-mobile mb-2 mb-md-3 ${showAllContracts ? ' show-other-contracts' : ''}`}>
               <h2 class="mb-0">{title}</h2>
               <div class="row contracts-wrap">
                  {contractList.map((data, index) => (
                     <Contract
                        segRefZ={segRefZ}
                        showAllContracts={showAllContracts}
                        focusedLink={index === 2 ? this.focusedLink : createRef()}
                        contractData={data}
                        nbOfContracts={contractList.length}
                        contractIndex={index + 1}
                        cardNumber={cardNumber}
                     />
                  ))}

                  {contractList.length > 3 ? (
                     <div class="col-12 mt-2 d-flex justify-content-center show-more-contracts-wrapper">
                        <button type="button" id="toggle-contracts" onclick={this.toggleContracts} class="btn btn-secondary">
                           {showAllContracts ? button.less_label : button.more_label}
                        </button>
                     </div>
                  ) : (
                     ''
                  )}
               </div>
            </div>
         </div>
      )
   }
}

// Composant de Contract
class Contract extends Component {
   render() {
      const nbOfContracts = this.props.nbOfContracts
      const cardNumber = this.props.cardNumber
      const contractIndex = this.props.contractIndex
      const showAllContracts = this.props.showAllContracts
      const segRefZ = this.props.segRefZ
      const { name, avatar_image, device_card, contract_type, device_image, contract_card, consumption_card, options_card, alert } = this.props.contractData

      return (
         <div
            class={nbOfContracts > 3 && contractIndex > 2 ? 'col-12 contract mt-2 mt-md-3 other-contract' : 'col-12 contract mt-2 mt-md-3'}
            data-testid={`contract-component${contractIndex}-${contract_type === 'mobile' ? 'mobile' : 'internet'}`}
            data-pdb-zid={`acc-digital_${segRefZ}_marchand_ligne${contractIndex}`}
         >
            <div class="contract-header">
               <img class="avatar-header" src={avatar_image} alt="" height="32" width="32" loading="lazy" />
               <h3 class="lead m-0 p-0" id={`contractName${contractIndex}`}>
                  {contract_type === 'mobile' ? <span dangerouslySetInnerHTML={{ __html: replaceSpaceByNbspOnPhoneNumber(name) }}></span> : <span>{name}</span>}
               </h3>
            </div>

            <div class="contract-wrapper">
               <div class={contract_type === 'mobile' ? 'img-mobile' : 'img-box'}>
                  <img
                     src={device_image}
                     alt=""
                     onerror={(event) => {
                        event.target.classList.add('d-none')
                     }}
                     loading="lazy"
                  />
               </div>

               <div class={`contract-card ob1-card ${cardNumber === 2 ? 'two-cards' : ''}`}>
                  <AlertMessage {...alert} />

                  {contract_type === 'mobile' ? (
                     <Fragment>
                        <CardDeviceMobile
                           device_card={device_card}
                           contractIndex={contractIndex}
                           segRefZ={segRefZ}
                           focusedLink={this.props.focusedLink}
                           showAllContracts={showAllContracts}
                           alert={alert}
                        />

                        <CardContractMobile contract_card={contract_card} contractIndex={contractIndex} segRefZ={segRefZ} />

                        {cardNumber === 3 ? <CardConsumptionMobile consumption_card={consumption_card} contractIndex={contractIndex} segRefZ={segRefZ} /> : ''}
                     </Fragment>
                  ) : (
                     ''
                  )}

                  {contract_type === 'internet' ? (
                     <Fragment>
                        <CardContractInternet
                           contract_card={contract_card}
                           contractIndex={contractIndex}
                           segRefZ={segRefZ}
                           focusedLink={this.props.focusedLink}
                           showAllContracts={showAllContracts}
                           alert={alert}
                        />

                        <CardOptionsInternet options_card={options_card} contractIndex={contractIndex} segRefZ={segRefZ} />
                     </Fragment>
                  ) : (
                     ''
                  )}
               </div>
            </div>
         </div>
      )
   }
}

// Alert message
const AlertMessage = (props) => {
   const { label, url } = props
   return (
      <Fragment>
         {!isEmptyObject(props) && label !== '' ? (
            <div class="alert-wrapper">
               <div class="alert alert-info" role="alert">
                  <span class="alert-icon" aria-hidden="true"></span>
                  <div class="alert-content">
                     {url !== '' ? (
                        <a href={url} class="o-link-arrow ob1-link-dark">
                           {label}
                        </a>
                     ) : (
                        <span>{label}</span>
                     )}
                  </div>
               </div>
            </div>
         ) : (
            ''
         )}
      </Fragment>
   )
}

// Card Contract Internet
const CardContractInternet = (props) => {
   const { contract_card, contractIndex, segRefZ, focusedLink, showAllContracts, alert } = props
   return (
      <div
         class="contract-card-item device_card lien-composite"
         data-testid="contract_card"
         data-oevent-category={`marchand_ligne${contractIndex}`}
         data-oevent-action={Slugify(contract_card.title)}
         data-oevent-label={contract_card.url}
         data-oevent-other={`{"track_refZ":"acc-digital_${segRefZ}_marchand_ligne${contractIndex}"}`}
      >
         <AlertMessage {...alert} />

         {/* Large Screen */}
         <h4 class="title-big m-0 p-0">{contract_card.title}</h4>
         <a
            href={contract_card.url}
            class="items-list-item"
            aria-describedby={`contractName${contractIndex}`}
            ref={focusedLink}
            tabindex={contractIndex === 3 && showAllContracts ? '0' : ''}
         >
            <div class="item-container">
               <div class="item-text">
                  <span class="item-title">{contract_card.description}</span>
               </div>
            </div>
         </a>

         {/* Small Screen boutique only */}
         <a
            href={contract_card.url}
            class="items-list-item d-none display-small"
            aria-describedby={`contractName${contractIndex}`}
            ref={focusedLink}
            tabindex={contractIndex === 3 && showAllContracts ? '0' : ''}
         >
            <div class="item-container">
               <div class="item-text">
                  <span class="item-title">{contract_card.title}</span>
                  <small class="item-desc">{contract_card.description}</small>
               </div>
            </div>
         </a>
      </div>
   )
}

// Card Options Internet
const CardOptionsInternet = (props) => {
   const { options_card, contractIndex, segRefZ } = props
   return (
      <div class="contract-card-item lien-composite" data-testid="options_card">
         {/* Large Screen */}
         <h4 class="title-big m-0 p-0">{options_card.title}</h4>
         <a
            href={options_card.url}
            class="items-list-item"
            data-oevent-category={`marchand_ligne${contractIndex}`}
            data-oevent-action={Slugify(options_card.title)}
            data-oevent-label={options_card.url}
            data-oevent-other={`{"track_refZ":"acc-digital_${segRefZ}_marchand_ligne${contractIndex}"}`}
            aria-describedby={`contractName${contractIndex}`}
         >
            <div class="item-container">
               <div class="item-text">
                  <span class="item-title">{options_card.description}</span>
               </div>
            </div>
         </a>

         {/* Small Screen boutique only */}
         <a
            href={options_card.url}
            class="items-list-item d-none display-small"
            data-oevent-category={`marchand_ligne${contractIndex}`}
            data-oevent-action={Slugify(options_card.title)}
            data-oevent-label={options_card.url}
            data-oevent-other={`{"track_refZ":"acc-digital_${segRefZ}_marchand_ligne${contractIndex}"}`}
            aria-describedby={`contractName${contractIndex}`}
         >
            <div class="item-container">
               <div class="item-text">
                  <span class="item-title">{options_card.title}</span>
                  <small class="item-desc">{options_card.description}</small>
               </div>
            </div>
         </a>
      </div>
   )
}

// Card Device Mobile
const CardDeviceMobile = (props) => {
   const { device_card, contractIndex, segRefZ, focusedLink, showAllContracts, alert } = props
   return (
      <div
         class="contract-card-item device_card lien-composite"
         data-testid="device_card"
         data-oevent-category={`marchand_ligne${contractIndex}`}
         data-oevent-action={Slugify(device_card.title)}
         data-oevent-label={device_card.url}
         data-oevent-other={`{"track_refZ":"acc-digital_${segRefZ}_marchand_ligne${contractIndex}"}`}
      >
         <AlertMessage {...alert} />

         {/* Large Screen */}
         <h4 class="title-big m-0 p-0">{device_card.title}</h4>
         <a
            href={device_card.url}
            class="items-list-item"
            aria-describedby={`contractName${contractIndex}`}
            ref={focusedLink}
            tabindex={contractIndex === 3 && showAllContracts ? '0' : ''}
         >
            <div class="item-container">
               <div class="item-text">
                  <span class="item-title">{device_card.device_name}</span>
                  <small class="item-desc">{device_card.description}</small>
               </div>
            </div>
         </a>

         {/* Small Screen boutique only */}
         <a
            href={device_card.url}
            class="items-list-item d-none display-small"
            aria-describedby={`contractName${contractIndex}`}
            ref={focusedLink}
            tabindex={contractIndex === 3 && showAllContracts ? '0' : ''}
         >
            <div class="item-container">
               <div class="item-text">
                  <span class="item-title">{device_card.title}</span>
                  <small class="item-desc">{device_card.device_name}</small>
               </div>
            </div>
         </a>
      </div>
   )
}

// Card Contract Mobile
const CardContractMobile = (props) => {
   const { contract_card, contractIndex, segRefZ } = props
   return (
      <div class="contract-card-item lien-composite" data-testid="contract_card">
         {/* Large Screen */}
         <h4 class="title-big m-0 p-0">{contract_card.title}</h4>
         <a
            href={contract_card.url}
            class="items-list-item"
            data-oevent-category={`marchand_ligne${contractIndex}`}
            data-oevent-action={Slugify(contract_card.title)}
            data-oevent-label={contract_card.url}
            data-oevent-other={`{"track_refZ":"acc-digital_${segRefZ}_marchand_ligne${contractIndex}"}`}
            aria-describedby={`contractName${contractIndex}`}
         >
            <div class="item-container">
               <div class="item-text">
                  <span class="item-title">{contract_card.contract_name}</span>
                  <small class="item-desc">{contract_card.description}</small>
               </div>
            </div>
         </a>

         {/* Small Screen boutique only */}
         <a
            href={contract_card.url}
            class="items-list-item d-none display-small"
            data-oevent-category={`marchand_ligne${contractIndex}`}
            data-oevent-action={Slugify(contract_card.title)}
            data-oevent-label={contract_card.url}
            data-oevent-other={`{"track_refZ":"acc-digital_${segRefZ}_marchand_ligne${contractIndex}"}`}
            aria-describedby={`contractName${contractIndex}`}
         >
            <div class="item-container">
               <div class="item-text">
                  <span class="item-title">{contract_card.title}</span>
                  <small class="item-desc">{contract_card.contract_name}</small>
               </div>
            </div>
         </a>
      </div>
   )
}

// Card consumption Mobile
const CardConsumptionMobile = (props) => {
   const { consumption_card, contractIndex, segRefZ } = props
   return (
      <div class="contract-card-item" data-testid="consumption_card">
         <h4 class="title-small text-gray3 p-0">{consumption_card.title}</h4>
         <a
            href={consumption_card.consumption_url}
            class="o-link-arrow o-link-small"
            data-oevent-category={`marchand_ligne${contractIndex}`}
            data-oevent-action={Slugify(consumption_card.consumption_label)}
            data-oevent-label={consumption_card.consumption_url}
            data-oevent-other={`{"track_refZ":"acc-digital_${segRefZ}_marchand_ligne${contractIndex}"}`}
            aria-describedby={`contractName${contractIndex}`}
         >
            {consumption_card.consumption_label}
         </a>
         <a
            href={consumption_card.invoice_url}
            class="o-link-arrow o-link-small"
            data-oevent-category={`marchand_ligne${contractIndex}`}
            data-oevent-action={Slugify(consumption_card.invoice_label)}
            data-oevent-label={consumption_card.invoice_url}
            data-oevent-other={`{"track_refZ":"acc-digital_${segRefZ}_marchand_ligne${contractIndex}"}`}
            aria-describedby={`contractName${contractIndex}`}
         >
            {consumption_card.invoice_label}
         </a>
      </div>
   )
}

/**
 * @input  "Pour vous - 07 87 21 43 73"
 * @output "Pour vous<span class="name-dash"> - </span><span class="name-phone-number">07&nbsp;87&nbsp;21&nbsp;43&nbsp;73</span>"
 * La class "name-dash" sert à supprimer le tiret en mobile
 * La class "name-phone-number" sert à aller à la ligne en mobile
 */
const replaceSpaceByNbspOnPhoneNumber = (txt) => {
   let titulaire = txt.substring(0, txt.lastIndexOf('-') - 1)
   let forfait = txt.substring(txt.lastIndexOf('-') + 2, txt.lastIndexOf('/') + 2)
   let numero = txt.substring(txt.lastIndexOf('/') + 2)
   return titulaire + '<span class="name-dash"> - </span><span class="name-phone-number">' + forfait + numero.replaceAll(' ', '&nbsp;') + '</span>'
}
